// extracted by mini-css-extract-plugin
export default {"button":"upgrade-successful_button__dPv0I"};